import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import IOSSwitch from "../../../users/formComponents/IOSSwitch";
import styles from "./modal.module.css";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "25dvw",
  //   height: "40dvh",
  minWidth: "200px",
  //   minHeight: "400px",
  // bgcolor: "#242743",
  // background: "rgba(0, 0, 0, 0.25)" /* dim background */,
  // background: "rgba(255, 255, 255, 0.25)" /* dim background */,
  // background: "rgba(0,0,0 )" /* dim background */,
  background: "#ffffffef",
  color: "#111111",
  backdropFilter: "blur(8px)",
  WebkitBackdropFilter: "blur(12px)",
  //   border: "1px solid #414466",
  boxShadow: 24,
  display: "flex",
  flexDirection: "column",
  outline: "none",
  borderRadius: "15px",
  padding: "20px",

  //   p: 4,
};

const headStype = {
  //   padding: "15px 15px",
  //   borderBottom: "1px solid #414466",
  display: "flex",
  alignItems: "start",
  justifyContent: "start",
};

const contentStyle = {
  //   padding: "15px 15px",
  flexGrow: "1",
  display: "flex",
  flexDirection: "column",
  overflow: "auto",
};

export default function GoalModal({ open, setOpen }) {
  //   const [confirm, setConfirm] = useState(false);
  return (
    <Modal
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className={styles.android12Modal}>
        <Box sx={headStype}>
          <Box sx={{ flexGrow: "1", textAlign: "center" }}>
            <Typography
              component={"span"}
              sx={{
                fontSize: { sm: "18px", lg: "18px", xs: "16px" },
                // color: "white",
                color: "#222",
                fontWeight: "bold",
              }}
            >
              MyNetGoals
            </Typography>
          </Box>
        </Box>

        <Box sx={contentStyle}>
          <Box sx={{ marginTop: "10px", flexGrow: "1" }}>
            <Typography
              component="p"
              sx={{
                // color: "#9091a1",
                color: "#222",
                fontSize: { sm: "14px", xs: "12px", md: "16px" },
              }}
            >
              Your club videos will no longer appear in public section of the
              app .
            </Typography>
          </Box>

          <Box
            sx={{
              marginTop: "10px",
              flexGrow: "1",
              display: "flex",
              flexDirection: "row-reverse",
              justifyContent: "center",
            }}
          >
            <Button
              onClick={() => {
                setOpen(false);
                // setConfirm(true);
              }}
              // sx={{ color: "#9091a1" }}
              sx={{ color: "#222" }}
            >
              Ok
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}
